module.exports = __webpack_public_path__ + "img/Product_Services_Close.168e4bba.png";